/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import LPBAdvancedForm from './LPBAdvancedForm';
import LPBSimpleForm from './LPBSimpleForm';
import { LPBSimpleModel, LPBAdvancedModel } from './Models';
import { LPBSimpleValidation, LPBAdvancedValidation } from './ModelValidators';
import { FORM_TYPES } from 'components/common/constants';

const LPBForm = (tableProps) => {
  const formType = tableProps.formType;

  const validationSchema =
    formType === FORM_TYPES.SIMPLE
      ? LPBSimpleValidation({ ...tableProps.validationProps, model: LPBSimpleModel })
      : LPBAdvancedValidation({ ...tableProps.validationProps, model: LPBAdvancedModel });
  const form = useFormik({ enableReinitialize: true, ...validationSchema });

  useEffect(() => {
    form.resetForm();
    tableProps.setIsFormResetAfterAccountChanging(true);
  }, [tableProps.account.wallet_number]);

  const formProps = { ...tableProps, validationSchema };
  return (
    <>
      {formType === FORM_TYPES.SIMPLE ? (
        <LPBSimpleForm commonForm={form} {...formProps} />
      ) : (
        <LPBAdvancedForm commonForm={form} {...formProps} />
      )}
    </>
  );
};

LPBForm.propTypes = {
  customerNumber: PropTypes.string,
  calculateCommission: PropTypes.func.isRequired,
  checkTransfer: PropTypes.func.isRequired,
  uploadDocuments: PropTypes.func.isRequired,
  iban: PropTypes.string,
  account: PropTypes.object,
  paymentMethod: PropTypes.string,
  commission: PropTypes.object,
  isCommissionLoading: PropTypes.bool,
  isLoading: PropTypes.bool,
  error: PropTypes.any,
  uploadedFiles: PropTypes.array,
  removePaymentFile: PropTypes.func,
  commonForm: PropTypes.object,
  currency: PropTypes.string,
  isSuccess: PropTypes.bool,
  // todo: describe validationProps object values
  validationProps: PropTypes.object.isRequired,
  isFormResetAfterAccountChanging: PropTypes.bool,
  setIsFormResetAfterAccountChanging: PropTypes.func
};

export default LPBForm;
